const accessUtils = {
  isCustomer: (user) => {
    return (user.groups.indexOf('LM_Guest') >= 0 && user.groups.indexOf('LM_Staff') < 0 && user.role !== 'admin');
  }
}

export default accessUtils